export default {
  name: 'marking--inputPChild',
  apiService: 'shoes',
  apiPath: '/admin/input_p_children',
};